import { useEffect, useState } from 'react'

export const EditableComponent = <T, ViewProps extends object, EditViewProps extends object>({
  storyId,
  value,
  modes,
  view: ViewComponent,
  editView: EditViewComponent,
  ...restProps
}: EditableProps<T, ViewProps, EditViewProps>) => {
  const [localValue, setLocalValue] = useState<T | null | undefined>(value)
  const [isEditMode, setIsEditMode] = useState(modes[0] === 'edit')

  // biome-ignore lint/correctness/useExhaustiveDependencies: value should not be tracked
  useEffect(() => {
    if (isEditMode && modes.includes('edit') && EditViewComponent) {
      setLocalValue(value)
    }
  }, [EditViewComponent, modes, isEditMode])

  const switchEditMode = () => {
    if (!EditViewComponent || !modes.includes('edit')) return

    setLocalValue(value)
    setIsEditMode(true)
  }

  const switchViewMode = () => {
    if (!ViewComponent || !modes.includes('view')) return

    setIsEditMode(false)
  }

  if (isEditMode && modes.includes('edit') && EditViewComponent) {
    return (
      <EditViewComponent
        storyId={storyId}
        value={localValue}
        switchViewMode={switchViewMode}
        {...(restProps as EditViewProps)}
      />
    )
  }

  if (!isEditMode && modes.includes('view') && ViewComponent) {
    return (
      <ViewComponent storyId={storyId} value={value} switchEditMode={switchEditMode} {...(restProps as ViewProps)} />
    )
  }

  return null
}
